import n from "react";
const c = (e, r, i = 0) => {
  if (!e)
    return e;
  if (Array.isArray(e))
    return e.map((t, a) => c(t, r, a));
  if (typeof r == "function") {
    const t = r(e.props, i);
    return n.isValidElement(t) ? t : n.cloneElement(e, t);
  }
  return n.isValidElement(r) ? r : n.cloneElement(e, r);
};
export {
  c
};
